import { motion } from "framer-motion";
import { Check } from "lucide-react";

export const ServiceTag = ({ label, selected, onSelect }) => (
  <motion.button
    type="button"
    onClick={() => onSelect(label)}
    className={`flex items-center justify-center text-sm font-medium border rounded-full px-4 py-2 transition-all duration-200 ${
      selected
        ? "bg-blue-600 text-white border-blue-600 shadow-lg shadow-blue-500/30"
        : "bg-slate-800/50 text-gray-300 border-slate-700 hover:bg-slate-700/60"
    }`}
    whileTap={{ scale: 0.95 }}
  >
    {selected && (
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        className="mr-2"
      >
        <Check className="w-4 h-4" />
      </motion.div>
    )}
    {label}
  </motion.button>
);
